import { render, staticRenderFns } from "./addCandidatesSectionModal.vue?vue&type=template&id=cb3dc16c&scoped=true"
import script from "./addCandidatesSectionModal.vue?vue&type=script&lang=js"
export * from "./addCandidatesSectionModal.vue?vue&type=script&lang=js"
import style0 from "./addCandidatesSectionModal.vue?vue&type=style&index=0&id=cb3dc16c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3dc16c",
  null
  
)

export default component.exports